import * as R from 'ramda'

import { buildUrl } from 'app/utils'
import http from 'services/http'

const apiUrl = buildUrl('/contrato/convenio')
const parametroUrl = buildUrl('/contrato/convenio-parametros/search/convenio')

export const findAll = filters => http.get('/contrato/convenio', filters)

export const find = R.compose(http.get, apiUrl)

export const findByCodigo = codigo => {
  const url = apiUrl(`${codigo}`)
  return http.get(url)
}

export const getParametros = convenioId => http.get(parametroUrl(), { convenioId })

export const getConvenioHorarioPermitido = () => http.get('/contrato/session/horario-permitido')

export const getConvenioEstabelecimentos = () => http.get(apiUrl() + '/estabelecimentos')

export const getConveniosByEstabelecimentoId = idEstabelecimento =>
  http.get(apiUrl() + `/folha-pagamento/${idEstabelecimento}`)

export default {
  findAll,
  find,
  getParametros,
  getConvenioHorarioPermitido,
  findByCodigo,
  getConvenioEstabelecimentos,
  getConveniosByEstabelecimentoId
}
